module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-cottonbro-agile2-dc748446442f0f136b762f780849dac5.jpg";